import { ShiftView } from "type/model/view";
import { isBetweenTime } from "utility/dateTime";

const timeInZone = (value: Date, timeZone: string) =>
  new Intl.DateTimeFormat("en-AU", { timeZone, hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .format(value)
    .replace(":", "");

export const currentShift = (shifts: ShiftView[], at: Date | number = Date.now()) =>
  shifts.find((shift) => shift.startTime && shift.endTime && isBetweenTime(at, shift.startTime, shift.endTime)) ?? null;

export const shiftLabel = (shift: ShiftView | null | undefined, timeZone: string) => {
  if (!shift?.startTime || !shift?.endTime) {
    return null;
  }

  return `${shift.name ?? ""} ${timeInZone(shift.startTime, timeZone)} - ${timeInZone(shift.endTime, timeZone)}`.trim();
};
